import React, { useState } from 'react'
import './ModaldropdownCss.css';
// import '../../components/Ai.css'

const Modal = (props) => {
    // console.log("modal", props);

    return (


        <div
            data-bs-keyboard="false"
            className={`modal fade ${props.show && 'show'}`}
            id="select_modal"
            data-backdrop="static"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            style={{ display: props.show ? "block" : "none" }}
        >
            <div
                className={"modal-dialog modal-dialog-centered "}
                // style={props.errors ? { maxWidth: '600px' } : ''}
                style={{ maxWidth: props.errors ? "300px" : "" }}

            >
                <div className="modal-content">
                    {props.modalHeader &&
                        // <div className="modal-header">
                        //     <h5 className="modal-title" id="exampleModalLabel">{props.title}</h5>
                        // <button
                        //     type="button"
                        //     className="close"
                        //     aria-label="Close"
                        //     onClick={() => props.closeModal()}
                        // >
                        //     <span aria-hidden="true">&times;</span>
                        // </button>
                        <>
                            <button disabled={props.closeDisabled} type="button" class="close_btn" data-bs-dismiss="modal" aria-label="Close" onClick={() => props.closeModal()}>X</button>
                            {/* </div> */}
                        </>
                    }


                    <div className="modal-body">

                        {props.modalBody}
                    </div>
                    {props.modalLoader &&
                        <div className='d-flex justify-content-center loader_popup'>
                            <div class="spinner-border text-white" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    }
                    {props.modalFooter &&
                        <div className="modal-footer">
                            {props.modalFooter}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Modal